import { Component, SimpleChanges } from '@angular/core';
import { ComponentModalBase } from '@framework/base';
import { Store } from '@ngrx/store';
import { CoreState } from '@app/store/core/states';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Actions, ofType } from '@ngrx/effects';
import { ToastService } from '@framework/services';
import { Subscription } from 'rxjs';
import { storyActions } from '@modules/story/store/actions';

@Component({
  selector: 'app-add-draft-email-modal',
  templateUrl: './add-draft-email-modal.component.html',
  styleUrls: ['./add-draft-email-modal.component.css']
})
export class AddDraftEmailModalComponent extends ComponentModalBase<any> {

  private createStoryCompletedSubscription: Subscription;
  private createStoryFailureSubscription: Subscription;

  public personForm: UntypedFormGroup;
  public isDuplicate: boolean = false;
  public getDraftLink: boolean = false;
  public generateUrl: any;
  /** True while CreateInbound is in flight — blocks cancel/close until it settles. */
  public isSaving: boolean = false;

  constructor(private store$: Store<CoreState>, private formBuilder: UntypedFormBuilder,
              private actions$: Actions, private toastService: ToastService) {
    super();
  }

  protected onAfterContentChecked(): void {
  }

  protected onAfterContentInit(): void {
  }

  protected onAfterViewChecked(): void {
  }

  protected onAfterViewInit(): void {
  }

  protected onChanges(changes: SimpleChanges): void {
  }

  protected onDestroy(): void {
    this.unsubscribe();
  }

  protected onDoCheck(): void {
  }

  protected onInit(): void {
    this.initForm();
    this.subscribe();
  }

  private subscribe() {
    this.createStoryCompletedSubscription = this.actions$.pipe(
      ofType<storyActions.CreateSuccess>(storyActions.ActionTypes.CREATE_SUCCESS)
    ).subscribe((action: storyActions.CreateSuccess) => {
      if (!this.isSaving) {
        return;
      }
      this.isSaving = false;
      this.getDraftLink = true;
      this.generateUrl = action?.data?.guest_draft_link;
      this.personForm.enable();
      this.toastService.success('Email Sent');
    });

    this.createStoryFailureSubscription = this.actions$.pipe(
      ofType<storyActions.CreateFailure>(storyActions.ActionTypes.CREATE_FAILURE)
    ).subscribe((action: storyActions.CreateFailure) => {
      if (!this.isSaving) {
        return;
      }
      this.isSaving = false;
      this.personForm.enable();
      const apiMsg =
        (action as any)?.error?.error?.error ||
        (action as any)?.error?.error?.message ||
        (action as any)?.error?.message;
      this.toastService.error(apiMsg || 'Could not save draft. Please try again.');
    });
  }

  private unsubscribe() {
    if (this.createStoryCompletedSubscription) {
      this.createStoryCompletedSubscription.unsubscribe();
    }
    if (this.createStoryFailureSubscription) {
      this.createStoryFailureSubscription.unsubscribe();
    }
  }

  private initForm() {
    this.personForm = this.formBuilder.group({
      firstname: ['', Validators.required],
      lastname: [''],
      email: ['', Validators.compose([Validators.required, Validators.email])]
    });
  }

  copyLink() {
    if (!this.generateUrl) {
      this.toastService.error('Draft link is not available yet. Please try saving again.');
      return;
    }
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = this.generateUrl.toString();
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.toastService.success('Copied');
  }

  public getLink() {
    if (this.isSaving || this.personForm.invalid) {
      return;
    }
    this.initialState.name_draft = this.personForm.value.firstname;
    this.initialState.name_lastname = this.personForm.value.lastname || '';
    this.initialState.name_email = this.personForm.value.email;
    this.isSaving = true;
    this.personForm.disable();
    this.store$.dispatch(new storyActions.CreateInbound(this.initialState));
  }

  public close() {
    // Block dismiss while create is in flight so Cancel cannot imply "not saved"
    // while the request still completes in the background.
    if (this.isSaving) {
      return;
    }
    if (this.getDraftLink) {
      this.onClose.emit(true);
    } else {
      this.onClose.emit(false);
    }
  }

}
